'use client'

import { UnauthenticatedPage } from '~/components/auth/UnauthenticatedPage'
import { useAuthUser } from '~/hooks/useAuthUser'
/**
 * This is a higher order component to block unauthenticated users from accessing a page.
 * Should only be used with page components.
 */
export const withAuthentication = <P extends object>(
  Component: React.ComponentType<P>,
) => {
  const WrappedComponent = (props: P) => {
    const { user: authUser } = useAuthUser()

    const isAuthenticated = !!authUser

    if (!isAuthenticated) {
      return <UnauthenticatedPage />
    }

    return <Component {...props} />
  }

  WrappedComponent.displayName = `withAuthentication(${
    Component.displayName || Component.name || 'Component'
  })`

  return WrappedComponent
}
